import * as React from "react";
import { useTranslation } from "react-i18next";
import { Alert } from "components/bootstrap";
const DataLakeBackendWarning = () => {
  const { t } = useTranslation("enterprise_data_lake");
  return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "warning" }, t("backend_warning.text"));
};
export default DataLakeBackendWarning;
